import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import CaptchaQuestion from "./CaptchaQuestion";

const GUARD = 'https://memoswap.frederic-delsert.com/guard.php';
const API = 'https://memoswap.frederic-delsert.com/form.php';

const App = () => {
  const [questionAndHash, setQuestionAndHash] = useState(null);
  const [errorState, setErrorState] = useState(null);
  const { register, handleSubmit, getValues, errors, reset, setError } = useForm();

  const fetchCaptcha = async () => {
    const response = await fetch(GUARD);
    if (!response.ok) {
      const message = await response.text()
      throw new Error(message);
    }
    return await response.json();
  }

  const getCaptcha = () => {
      fetchCaptcha()
      .then(data => {
        setQuestionAndHash(data);
      })
      .catch(error => {
        setErrorState(error.message);
      });
  };

  const postSubmit = async () => {
    const response = await fetch(API, {
      method: 'POST',
      body: JSON.stringify({...getValues(), ...questionAndHash})
    });
    if (!response.ok) {
      const message = await response.text()
      throw new Error(message);
    }
    return await response.json();
  }

  const onSubmit = () => {
    postSubmit()
    .then(data => {
      if(!data.success){
        if(data.errors){
          for (const [key, value] of Object.entries(data.errors)) {
            setError(key, {
              type: "manual",
              message: value
            });
          }
        }
      }else {
        alert('Your message has been sent.');
        reset();
        getCaptcha();
        setErrorState(null);
      }
    })
    .catch(error => { setErrorState(error.message);});
  }

  useEffect(getCaptcha, []);

  return(
      <form id="contact-form" onSubmit={handleSubmit(onSubmit)} autocomplete="off">
            <h3 class="title">Contact us</h3>
            <div class="input-container">
              <input type="text" name="name" ref={register({ required: true })} className="input" />
              {errors.name && <span>{errors.name.message}</span>}
              <label for="name">Name</label>
              <span>Name</span>
            </div>
            <div class="input-container">
              <input type="email" name="email" ref={register({ required: true })} className="input" aria-describedby="emailHelp"  />
              {errors.email && <span>{errors.email.message}</span>}
              <label for="email">Email</label>
              <span>Email</span>
            </div>
            <div class="input-container textarea">
              <textarea name="message" ref={register({ required: true })} className="input" />
              {errors.message && <span>{errors.message.message}</span>}
              <label for="message">Message</label>
              <span>Message</span>
            </div>
            <div class="input-container">
            <input type="text" name="answer" ref={
                register({ 
                  required: true,
                  validate: value => parseInt(value, 10) >= 0,
                })
               } className="input"/>
              {errors.answer && <span>{errors.answer.message}</span>}
              <label for="answer">{questionAndHash && <CaptchaQuestion question={questionAndHash.expression}/>}</label>
              <span>---------</span>
            </div>
            <button type="submit" className="btn">Submit</button>
          </form>
    );  
}

export default App